import { cn } from "~/lib/utils";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

interface Props {
  direction: "left" | "right";
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const ScrollArrowButton = ({ direction, onClick, disabled, className }: Props) => {
  const Icon = direction === "left" ? IoIosArrowBack : IoIosArrowForward;

  return (
    <button
      className={cn(
        "flex items-center justify-center py-2 px-2 bg-cardBgColor rounded-full transition-opacity duration-200",
        disabled && "cursor-not-allowed",
        !disabled && "hover:bg-chipHoverColor",
        className,
      )}
      onClick={onClick}
      disabled={disabled}
      aria-label={`Scroll ${direction}`}
    >
      <Icon size={24} color={disabled ? "#e7c297" : "#572713"} />
    </button>
  );
};

export default ScrollArrowButton;
